export enum WhatsappTemplateStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
